/**
 * Sessoes abertas na plataforma.
 *
 * A pergunta que esta tela responde e "quem esta logado agora?" -- e a acao
 * que ela oferece e derrubar. Nao ha criacao nem edicao: sessao nasce de um
 * login e morre de um logout ou de um clique aqui.
 *
 * Revogar vale para a plataforma inteira, nao so para o accounts: todos os
 * tokens de uma mesma entrada carregam o mesmo `sid`, inclusive os que o SSO
 * emitiu para as outras aplicacoes.
 */
export const nav = {
    section: 'Resources',
    title: 'Sessions',
    icon: 'devices',
    route: '/sessoes',
    accordion: false,
    permissao: 'accounts.sessoes:ver',
};

export default [
    {
        path: '/sessoes',
        name: '/sessoes',
        component: () => import('./pages/SessoesListPage.vue'),
        meta: { requiresAuth: true, permissao: 'accounts.sessoes:ver' },
    },
];
